import { render, staticRenderFns } from "./downloadDialog.vue?vue&type=template&id=b13967fa&scoped=true"
import script from "./downloadDialog.vue?vue&type=script&lang=js"
export * from "./downloadDialog.vue?vue&type=script&lang=js"
import style0 from "./downloadDialog.vue?vue&type=style&index=0&id=b13967fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13967fa",
  null
  
)

export default component.exports